var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 17,
    viewBox: "0 0 59 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45592 0.131164C5.98302 0.128011 7.54953 -0.0130773 8.21307 2.22638C8.66004 3.7349 9.37203 6.20593 10.3491 9.63947H10.747C11.7947 6.01959 12.5145 3.54856 12.9062 2.22638C13.5767 -0.036405 15.2528 0.131209 15.9233 0.131209L21.096 0.131215V16.2221H15.8238V6.73947H15.4703L12.5313 16.2221H8.56469L5.62571 6.73244H5.27217V16.2221H0V0.131215L5.45592 0.131164ZM28.6667 0.131215V9.62089H29.0873L32.6623 1.8176C33.3563 0.26472 34.8354 0.131215 34.8354 0.131215H39.9373V16.2221H34.555V6.73244H34.1344L30.6295 14.5357C29.9355 16.0816 28.3864 16.2221 28.3864 16.2221H23.2845V0.131215H28.6667ZM58.5408 7.77772C57.7901 9.90523 55.4323 11.4289 52.822 11.4289H47.1776V16.2221H42.0594V7.77772H58.5408Z",
    fill: "#0F754E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0689 0.131592H41.791C42.0594 3.71397 45.1445 6.78072 48.3381 6.78072H58.8965C59.5058 3.80334 57.4083 0.131592 53.0689 0.131592Z",
    fill: "url(#paint0_linear_6667_474969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6667_474969",
    x1: 59,
    y1: 4.31418,
    x2: 41.791,
    y2: 4.31418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.023e9f5e5a2f5ea4c1d37d77355b41ff.svg";
export { ForwardRef as ReactComponent };